import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios'
axios.defaults.baseURL = 'https://teachers.studioclassroom.com/api'
//import moment from 'moment'
//import { cloneDeep, isEmpty } from 'lodash'
//import { months } from '@/helpers/date'
const state = {
    src: 'https://teachersdownload.s3.ap-northeast-1.amazonaws.com/',
    image: {
      //src: 'https://teachersdownload.s3.ap-northeast-1.amazonaws.com/',
      //images: ['christmas2.jpg','doris_story.jpg'],
      //image_fn: ['christmas2.jpg','christmas.jpg','doris_story.jpg'],
      image_fn: [],
      link: [],
      ads_ImageSrc: null,
      ads_Url: null
  
    },
    imgae2: [
      { id: 1, 
        image_fn: 'christmas2.jpg',
        link: "https://thejourneyoflove.ortv.com/"
      },
      { id: 2, 
        image_fn: 'christmas.jpg',
        link: "https://thejourneyoflove.ortv.com/"
      },
      { id: 3, 
        image_fn: 'doris_store.jpg',
        link: "https://thejourneyoflove.ortv.com/"
      },
    ]
    
}

const getters = {

}

const actions = {
  
	//image_fn: axios.get('getAds.php')
  
   async FetchAds() {
    
    let response = await axios.get(`getAds.php`)
    
    await dispatch('fetchAds', response.data.data)
	
  },

}

const mutations = {
    getAds2(state){
        //store.dispatch("getAds");
      store.getters.getimage2ById(2);
    },
    getAds (state) {
      store.getters.getimage2ById(2);
    }
  
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}